var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg403(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 18.62H20.6667L31 4.13666H19.6667L9.33334 18.62H10.3333Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9667 4.13666H57.93L47.5967 18.62H58.9667C59.2407 18.62 59.5036 18.5111 59.6974 18.3173C59.8911 18.1235 60 17.8607 60 17.5867V5.17332C60.0005 5.03735 59.9741 4.90262 59.9223 4.77686C59.8706 4.65111 59.7945 4.5368 59.6985 4.44049C59.6025 4.34418 59.4885 4.26777 59.3629 4.21563C59.2373 4.1635 59.1027 4.13666 58.9667 4.13666Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3099 18.62L49.6432 4.13666H39.3099L28.9766 18.62H39.3099Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 4.13666H1.03334C0.897359 4.13666 0.762715 4.1635 0.637128 4.21563C0.51154 4.26777 0.397478 4.34418 0.301481 4.44049C0.205483 4.5368 0.129438 4.65111 0.0777044 4.77686C0.025971 4.90262 -0.000433269 5.03735 5.37683e-06 5.17332V17.5867C5.37683e-06 17.8607 0.108874 18.1235 0.302662 18.3173C0.496449 18.5111 0.759282 18.62 1.03334 18.62L11.3667 4.13666H10.3333Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6667 39.31H58.9667C59.2407 39.31 59.5036 39.2011 59.6974 39.0073C59.8911 38.8136 60 38.5507 60 38.2767V25.8633C60.0005 25.7273 59.9741 25.5926 59.9223 25.4669C59.8706 25.3411 59.7945 25.2268 59.6985 25.1305C59.6025 25.0342 59.4885 24.9578 59.3629 24.9056C59.2373 24.8535 59.1027 24.8267 58.9667 24.8267H57.93L47.5967 39.31H49.6667Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 24.8267L9.33334 39.31H20.69L31.0233 24.8267H19.6667Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3099 24.8267L28.9766 39.31H39.3099L49.6432 24.8267H39.3099Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 24.8267H1.03334C0.897359 24.8267 0.762715 24.8535 0.637128 24.9056C0.51154 24.9578 0.397478 25.0342 0.301481 25.1305C0.205483 25.2268 0.129438 25.3411 0.0777044 25.4669C0.025971 25.5926 -0.000433269 25.7273 5.37683e-06 25.8633V38.2767C5.37683e-06 38.5507 0.108874 38.8136 0.302662 39.0073C0.496449 39.2011 0.759282 39.31 1.03334 39.31L11.3667 24.8267H10.3333Z",
    fill: "#FF6243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 1.03333C10.3334 0.761 10.2259 0.499672 10.0342 0.306169C9.84262 0.112667 9.58235 0.00263548 9.31003 0L7.24003 0C6.96597 0 6.70314 0.108869 6.50935 0.302656C6.31556 0.496444 6.2067 0.759276 6.2067 1.03333V4.13667H10.3334V1.03333Z",
    fill: "#898890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 18.62H6.2067V24.8267H10.3334V18.62Z",
    fill: "#898890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2067 39.31V55.8633H10.3334V39.31H6.2067Z",
    fill: "#898890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.10334 55.8633C2.82928 55.8633 2.56645 55.9722 2.37266 56.166C2.17888 56.3598 2.07001 56.6226 2.07001 56.8967V58.9667C2.07001 59.2407 2.17888 59.5036 2.37266 59.6974C2.56645 59.8911 2.82928 60 3.10334 60H13.4367C13.5727 60.0005 13.7074 59.9741 13.8331 59.9223C13.9589 59.8706 14.0732 59.7945 14.1695 59.6985C14.2658 59.6025 14.3422 59.4885 14.3944 59.3629C14.4465 59.2373 14.4733 59.1027 14.4733 58.9667V56.8967C14.4733 56.7607 14.4465 56.6261 14.3944 56.5005C14.3422 56.3749 14.2658 56.2608 14.1695 56.1648C14.0732 56.0688 13.9589 55.9928 13.8331 55.941C13.7074 55.8893 13.5727 55.8629 13.4367 55.8633H3.10334Z",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7933 1.03333C53.7933 0.759276 53.6845 0.496444 53.4907 0.302656C53.2969 0.108869 53.034 0 52.76 0L50.69 0C50.4177 0.00263548 50.1574 0.112667 49.9658 0.306169C49.7741 0.499672 49.6666 0.761 49.6667 1.03333V4.13667H53.8033L53.7933 1.03333Z",
    fill: "#898890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6667 18.62H53.8033V24.8267H49.6667V18.62Z",
    fill: "#898890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6667 39.31H53.8033V55.8633H49.6667V39.31Z",
    fill: "#898890"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5533 55.8633C46.4173 55.8629 46.2826 55.8893 46.1568 55.941C46.031 55.9928 45.9167 56.0688 45.8204 56.1648C45.7241 56.2608 45.6477 56.3749 45.5956 56.5005C45.5434 56.6261 45.5166 56.7607 45.5166 56.8967V58.9667C45.5166 59.1027 45.5434 59.2373 45.5956 59.3629C45.6477 59.4885 45.7241 59.6025 45.8204 59.6985C45.9167 59.7945 46.031 59.8706 46.1568 59.9223C46.2826 59.9741 46.4173 60.0005 46.5533 60H56.8866C57.1607 60 57.4235 59.8911 57.6173 59.6974C57.8111 59.5036 57.9199 59.2407 57.9199 58.9667V56.8967C57.9199 56.6226 57.8111 56.3598 57.6173 56.166C57.4235 55.9722 57.1607 55.8633 56.8866 55.8633H46.5533Z",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6665 4.13666H11.3799L1.0332 18.62H9.30987L19.6665 4.13666Z",
    fill: "#D8D7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9665 18.62L39.2999 4.13666H31.0332L20.6999 18.62H28.9665Z",
    fill: "#D8D7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5867 18.62L57.92 4.13666H49.6667L39.3333 18.62H47.5867Z",
    fill: "#D8D7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6665 24.8267H11.3799L1.04654 39.31H9.30987L19.6665 24.8267Z",
    fill: "#D8D7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0332 24.8267L20.6999 39.31H28.9665L39.2999 24.8267H31.0332Z",
    fill: "#D8D7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3099 39.31H47.5866L57.9199 24.8267H49.6666L39.3099 39.31Z",
    fill: "#D8D7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2067 18.62H10.3334V21.7233H6.2067V18.62Z",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6667 18.62H53.8033V21.7233H49.6667V18.62Z",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2067 39.31H10.3334V42.4133H6.2067V39.31Z",
    fill: "#787680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6667 39.31H53.8033V42.4133H49.6667V39.31Z",
    fill: "#787680"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403);
export default __webpack_public_path__ + "static/media/403.3f5049e01d6edce33243788ece5eb81f.svg";
export { ForwardRef as ReactComponent };